// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Format = require("bs-platform/lib/js/format.js");

function min(a, b) {
  if (a.lt(b)) {
    return a;
  } else {
    return b;
  }
}

function max(a, b) {
  if (a.gt(b)) {
    return a;
  } else {
    return b;
  }
}

function pp_print(f, x) {
  return Format.pp_print_string(f, x.toString());
}

exports.min = min;
exports.max = max;
exports.pp_print = pp_print;
/* Format Not a pure module */
